export const DATE_FORMATS = {
	dd_mm_yyyy: 'DD/MM/YYYY', // format to show on layout
	yyyy_mm_dd: 'YYYY-MM-DD'
};

export const BOOKING_STATUS = {
  status_created: 1,
  status_waiting_payment: 2,
  status_paid: 3,
  status_finding_nurse: 4,
	status_waiting_nurse_to_accept: 5,
	status_waiting_customer_to_accept: 6,
  status_nurse_assigned: 7,
  status_nurse_got_kit_test: 12,
  status_nurse_got_sample_test: 13,
  // in process
  status_waiting_result: 8,
  // pass booking
  status_completed: 9,
  status_cancelled: 10,
	status_closed: 11
};

export const USER_ROLES = {
	nurse: 'nurse',
	customer: 'customer',
};

export const ROUTE_PREFIX_PARAMS = {
	nurse: 'Nurse',
	customer: 'Customer'
};

export const PAGES_HAVE_BACK_BTN = [
	'/danh-sach-dia-chi',
];

export const PAYMENT_METHODS = {
  card: 'CARD',
  transfer: 'BANK_TRANSFER'
};

export const TRANSACTION_STATUS = {
  pending: 'PENDING',
  done: 'DONE'
};

export const BOOKING_HOURS = [
	// {
	// 	id: 5,
	// 	name: '05:00',
	// },
	{
		id: 6,
		name: '06:00',
	},
	{
		id: 7,
		name: '07:00',
	},
	{
		id: 8,
		name: '08:00',
	},
	{
		id: 9,
		name: '09:00',
	},
	{
		id: 10,
		name: '10:00',
	},
	{
		id: 11,
		name: '11:00',
	},
	{
		id: 12,
		name: '12:00',
	},
	{
		id: 13,
		name: '13:00',
	},
	{
		id: 14,
		name: '14:00',
	},
	{
		id: 15,
		name: '15:00',
	},
	{
		id: 16,
		name: '16:00',
	},
	{
		id: 17,
		name: '17:00',
	},
	{
		id: 18,
		name: '18:00',
	},
	{
		id: 19,
		name: '19:00',
	},
	{
		id: 20,
		name: '20:00',
	},
	{
		id: 21,
		name: '21:00',
	},
	{
		id: 22,
		name: '22:00',
	},
	{
		id: 23,
		name: '23:00',
	},
];

export const LAB_BOOKING_HOURS = [
	{
		id: 5,
		name: '05:00',
	},
	{
		id: 6,
		name: '06:00',
	},
	{
		id: 7,
		name: '07:00',
	},
	{
		id: 8,
		name: '08:00',
	},
	{
		id: 9,
		name: '09:00',
	},
	{
		id: 10,
		name: '10:00',
	},
	{
		id: 11,
		name: '11:00',
	},
	{
		id: 12,
		name: '12:00',
	},
	{
		id: 13,
		name: '13:00',
	},
	{
		id: 14,
		name: '14:00',
	},
	{
		id: 15,
		name: '15:00',
	},
	{
		id: 16,
		name: '16:00',
	}
];

export const BOOKING_MINUTES = [
	{
    id: 0,
		name: '00',
	},
	{
		id: 15,
		name: '15',
	},
	{
		id: 30,
		name: '30',
	},
  {
		id: 45,
		name: '45',
  }
];

export const LAB_BOOKING_MINUTES = [
	{
    id: 0,
		name: '00',
	},
	{
		id: 15,
		name: '15',
	},
	{
		id: 30,
		name: '30',
	},
	{
		id: 45,
		name: '45',
  }
];

export const PARAMS_OF_BOOKING_LIST = {
	sort_asc: 'appointmentDate',
	limit: 9
};
export const PARAMS_OF_REQUESTS = {
	sort_asc: 'Relationbooking_appointmentDate',
	limit: 9
};

export const SESSION_PARAMS = {
	bookingTabIdOfCustomer: 'booking_tab_id_of_customer',
	bookingTabIdOfNurse: 'booking_tab_id_of_nurse',
	searchKey: 'search_key'
}

export const TAB_IDS = {
	tabOne: 'tab-1',
	tabTwo: 'tab-2',
	tabThree: 'tab-3',
};

export const INIT_FILE_SIZE = 1024 * 1024 * 7; // 7MB

export const NURSE_STATUS = {
	authenticating: 0,
	validated: 1,
	unauthenticated: 2
};

export const ADDRESS_STATUS = {
	default: 1,
	isNotDefault: 0,
};

export const BLOOD_TEST_FEE = 150000;

export const BLOOD_TEST_CARD = {
	id: 8472, // id on the server of the cate [Blood test]
	name: 'lab.bloodTestAtHome',
	bloodTestPath: '/dich-vu-xet-nghiem',
	image: '/img/blood-test.jpg'
}

export const BOOKING_ERRORS = {
	noNurseNearBy: 'no_nurse_nearby',
	noNurseMatchWithTime: 'no_nurse_match_with_time'
};
